<template>
  <div>
    <BaseTitle :title="$t('menu.quiz')" :yearPeriode="titleData" />
    <div>
      <v-card class="mb-5" v-for="lists in quizList.quizQuestions" v-bind:key="lists.quizQuestionId">
        <template>
          <div class="pa-5 d-flex justiy-space-between align-items section-header active">
            <div class="student-title">{{ $t('question.question') }} {{ lists.quizQuestionNo }}</div>
            <v-spacer />
            <div class="student-title">{{ $t('menu.score') }}: {{ lists.score }}</div>
          </div>
        </template>
        <template>
          <div class="assignment-content">
            <div class="mt-6">
              <p>{{ lists.quizQuestion }}.</p>
              <img
                :src="lists.imageUrl"
                style="
                      width : 50%;
                      height : 30%;
                      flex: 1;
                    "
              />
            </div>
            <div class="ml-3" v-if="lists.quizTypeId === 1">
              <!-- <div v-for="radio in lists.quizAnswers" v-bind:key="radio.quizAnswerId"> -->
              <v-radio-group v-model="lists.studentAnswers[0].answer">
                <v-radio
                  class="pa-2 compact-form"
                  v-for="radio in lists.quizAnswers"
                  v-bind:key="radio.quizAnswerId"
                  :label="`${radio.answer} ${$t(radio.correctAnswer ? 'content.correct_answer' : '')}`"
                  :value="radio.quizAnswerId"
                  disabled
                  color="info"
                ></v-radio>
              </v-radio-group>
              <!-- </div> -->
            </div>
            <div class="ml-3" v-if="lists.quizTypeId === 2">
              <v-checkbox
                color="info"
                class="compact-form"
                v-for="radio in lists.quizAnswers"
                v-bind:key="radio.quizAnswerId"
                disabled
                v-model="lists.answerMultiple"
                :label="`${radio.answer} ${$t(radio.correctAnswer ? 'content.correct_answer' : '')}`"
                :value="radio.quizAnswerId"
              />
            </div>
            <div class="ml-3" v-if="lists.quizTypeId === 3">
              <v-textarea v-model="lists.studentAnswers[0].answer" disabled class="compact-form" :label="$t('content.your_answer')" />
            </div>
            <div class="ml-3" v-if="lists.quizTypeId === 4">
              <v-text-field
                v-for="(radio, idx) in lists.studentAnswers"
                v-bind:key="idx"
                disabled
                class="compact-form"
                v-model="radio.answer"
                :label="
                  `${$t('content.your_answer')} ${$t('content.is')} ${$t(radio.correct ? 'content.correct' : 'content.incorrect')} ${$t(
                    'content.correct_answer'
                  )} '${radio.answer}' `
                "
              />
            </div>
            <div class="ml-3" v-if="lists.quizTypeId === 5">
              <v-text-field
                class="compact-form"
                v-for="(radio, idx) in lists.studentAnswers"
                v-bind:key="idx"
                disabled
                v-model="radio.answer"
                :label="` ${$t('content.your_answer')} ${$t('content.is')} ${$t(radio.correct ? 'content.correct' : 'content.incorrect')} `"
              />
            </div>
          </div>
        </template>
      </v-card>
      <!-- <v-card class="mb-5">
        <template>
          <div class="pa-5 d-flex justiy-space-between align-items section-header active">
            <div class="student-title">Questions 3</div>
            <v-spacer />
            <div class="student-title">Score: 10</div>
          </div>
        </template>
        <template>
          <div class="assignment-content">
            <div class="mt-6">
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
                minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
              </p>
            </div>
            <div class="ml-3">
              <v-textarea v-model="description" :label="$t('content.your_answer')" />
            </div>
          </div>
        </template>
      </v-card>
      <v-card class="mb-5">
        <template>
          <div class="pa-5 d-flex justiy-space-between align-items section-header active">
            <div class="student-title">Questions 4</div>
            <v-spacer />
            <div class="student-title">Score: 10</div>
          </div>
        </template>
        <template>
          <div class="assignment-content">
            <div class="mt-6">
              <p>
                (?)Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
                ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo(?)
              </p>
            </div>
            <div class="ml-3">
              <v-text-field v-model="answer" :label="$t('content.your_answer')" />
              <v-text-field v-model="answer" :label="$t('content.your_answer')" />
            </div>
          </div>
        </template>
      </v-card> -->

      <div class="d-flex justify-end align-center">
        <v-btn color="primary" class="btn-primary-custom mr-3" outlined @click="back">{{ $t('back') }}</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTitle from '@/components/base/Title';

export default {
  name: 'StudentAssignmentScoreQuiz',
  components: {
    BaseTitle
  },
  computed: {
    ...mapGetters({
      user: 'Auth/user',
      nameCourse: 'CourseList/nameCourse'
    })
  },
  sockets: {
    connect() {
      console.log('socket connected');
    },
    updateDetailAssignment({ classId, courseId, assignmentId }) {
      const { classId: currentClassId, courseId: currentCourseId, assignmentId: currentAssignmentId } = this.$route.params;
      if (classId == currentClassId && courseId == currentCourseId && assignmentId == currentAssignmentId) {
        this.$store.dispatch('general/showSuccessNotification', { message: this.$t('alert.list_assignment') });
        setTimeout(() => {
          this.$router.push({ name: 'StudentAssignment' });
        }, 400);
      }
    }
  },
  data: () => ({
    submitData: false,
    loading: false,
    checkbox: false,
    radioGroup: '',
    description: '',
    dataClass: '',
    answer: '',
    baseUrl: process.env.VUE_APP_BASE_URL,
    quizList: '',
    titleData: ''
  }),
  methods: {
    getData() {
      var submissionId = this.$route.params.submissionId;
      this.$store
        .dispatch('Assignment/fetchViewQuiz', { submissionId })
        .then(res => {
          res.quizQuestions.forEach(data => {
            data.studentAnswers.forEach(resa => {
              if (data.quizTypeId === 1) {
                resa.answer = parseInt(resa.answer);
              }
              if (data.quizTypeId === 2) {
                let dataQuiz = data.studentAnswers.reduce((acc, row) => {
                  acc.push(parseInt(row.answer));
                  return acc;
                }, []);
                data.answerMultiple = dataQuiz;
              }
            });
          });
          this.quizList = res;
        })
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e));
    },
    // countDownTimer() {
    //   if (this.countDown > 0) {
    //     setTimeout(() => {
    //       this.countDown -= 1;
    //       this.countDownTimer();
    //       localStorage.setItem('timeQuiz', this.countDown);
    //     }, 1000);
    //   } else {
    //     localStorage.removeItem('timeQuiz');
    //     this.$router.push({ name: 'StudentAssignmentDetail' });
    //   }
    // },
    getDataClass() {
      if (!this.$route.params.classSectionId) {
        this.$store
          .dispatch('Class/fetchClassroomCourseName', { classId: this.$route.params.classId, courseId: this.$route.params.courseId })
          .then(res => {
            if (this.user.cerdasTypeId === 2 || this.user.cerdasTypeId === null) {
              this.$store.dispatch('SchoolClass/fetchDetail', this.$route.params.classId).then(resa => {
                this.dataClass = resa;
                this.titleData = res + ` ( ${resa.yearPeriode} ) `;
              });
            } else {
              this.$store.dispatch('Class/fetchListLiteDetail', this.$route.params.classId).then(resa => {
                this.dataClass = resa;
                this.titleData = res + ` ( ${resa.yearPeriode} ) `;
              });
            }
          });
      } else {
        this.$store.dispatch('ClassSection/getListDetail', { classSectionId: this.$route.params.classSectionId }).then(res => {
          if (this.user.cerdasTypeId === 2 || this.user.cerdasTypeId === null) {
            this.$store.dispatch('SchoolClass/fetchDetail', this.$route.params.classId).then(resa => {
              this.dataClass = resa;
              this.titleData = res.classroomName + ` ${res.numberClass}` + ` ( ${resa.yearPeriode} ) `;
            });
          }
        });
      }
    },
    back() {
      this.$router.push({ name: 'StudentAssignmentDetail' });
    }
  },
  created() {
    this.getDataClass();
    this.getData();
  }
};
</script>

<style lang="scss" scoped>
.compact-form {
  transform: scale(0.875);
  transform-origin: left;
}
.succ {
  min-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-family: Montserrat;
  font-weight: 500;

  &-content {
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 20px;
    font-size: 12px;
  }

  &-featured {
    width: 100%;
    margin-bottom: 30px;
  }

  &-heading {
    color: #6d6d6d;
    font-family: Montserrat;
    font-weight: bold;
    font-size: 16px;
  }
}
.assignment {
  &-title {
    padding-bottom: 20px;
    margin-bottom: 20px;
    border-bottom: 1px solid #acacac;
  }

  &-icon {
    width: 48px;
    height: 48px;
    border-radius: 8px;
    background: #fff0da;
    color: #f1b65a;
    box-sizing: border-box;
    text-align: center;
    margin-right: 16px;

    svg {
      transform: scale(1.6);
      margin-top: 15px;
    }
  }

  &-content {
    margin: 10px 20px 20px 20px;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.6);
    font-family: Montserrat;
    line-height: 20px;
    text-align: left;
  }
  &-desc {
    line-height: 1.8em;
    padding-left: 65px;
  }
}

.section-header {
  border-radius: 8px 8px 0px 0px;

  &.active {
    background: #00BF63;
    .student-title {
      color: #fff;
      font-size: 18px;
      font-weight: bold;
    }
  }

  &.disabled {
    background: #acacac;
    pointer-events: none;

    .student-title {
      color: #fff;
    }
  }
}
</style>
